module.exports = __webpack_public_path__ + "img/velaine-immo-logo.06672bb.png";